import React from 'react'
import "../../../styles/pages-styles/main-dashboard-pages-styles/user-sidebar-pages/AlreadySubscribed.css";
import { Check, HomeIcon, X } from 'lucide-react';

const AlreadySubscribed = () => {
  return (
      <div>
        <div className="subscribe-container">
              <div className="subscribe-header">
                  <Check className="subscribe-icon" size={50} color="#4CAF50" />
            <h1 className="subscribe-title">Already Subscribed</h1>
            <p className="subscribe-subtitle">
              You are already subscribed to the premium plan.
                  </p>
                  <div>
                      <button><HomeIcon /> Go Home</button>
                      <button><X/> Cancel</button>
                  </div>
          </div>
        </div>
    </div>
  )
}

export default AlreadySubscribed